<template>
  <modal name="PopupAboutTask" @before-open="beforeOpen" @before-close="beforeClose"  draggable=".popup-header" :adaptive="true" :scrollable="true" height="auto">
    <div class="popup-header flex-row">
      <span class="flex-expand padding-half">{{ task.visibleId }}: {{ task.name }}</span>
      <button class="btn" @click="$modal.hide($options.name)"><i class="fal fa-times"></i></button>
    </div>
    <div class="content padding">
      <div v-html="task.description"></div>
      <div class="pure-u-1 form-row txt-l">
          <vue-element-loading :active="isDefaultFilesLoading"/>
          <div class="form-row margin-b padding-b">
            <stage-files-uploader
            :upload-url="uploadUrl"
            ref="descriptional_files_uploader" 
            input-name="descriptional_files"
            :multiple="true"
            :value="descriptionalFiles"
            title="Прилагаемые файлы"
            background="#888888"
            foreground="#FFFFFF"
            disabled/>
          </div>
        </div>
    </div>
  </modal>
</template>

<style scoped>

</style>

<script>
import {SET_LAST_SELECTED_TASK } from "@/store/actions/project"
import Task from '@/models/task'
import VueElementLoading from 'vue-element-loading'
import StageFilesUploader from '@/components/StageFilesUploader.vue'
import { apiCall } from "@/utils/api"
import {
  FILE_TYPE_DESCRIPTIONAL
} from "@/utils/const"

export default {
  name: 'PopupAboutTask',
  components: {
    VueElementLoading,
    StageFilesUploader
  },
  data() {
    return {
      task: Object.assign(new Task, {}),

      isDefaultFilesLoading: false,
      descriptionalFiles: [],
    }
  },
	methods: {
    beforeClose(event) {
      if (this.$escStack.length && this.$escStack[this.$escStack.length-1] == this.$options.name) {
        this.$escStack.pop()
      } else {
        event.cancel()
      }
    },
    beforeOpen(data) {
      this.task = data.params
      this.$store.dispatch(SET_LAST_SELECTED_TASK, this.task.id)
      this.loadDefaultFiles()

      this.$escStack.push(this.$options.name)
    },
    loadDefaultFiles() {
      if (!this.task.id) {
        return
      }
      this.isDefaultFilesLoading = true;
      apiCall({ url: 'tasks/' + this.task.id + '/files/' + FILE_TYPE_DESCRIPTIONAL, method: "GET"})
			.then(resp => {
        this.descriptionalFiles = resp
				this.isDefaultFilesLoading = false
			})
    },
	}
}
</script>